/**
 * Resolve a backend-declared lucide icon name (PascalCase, e.g. 'Users')
 * to its Vue component, with a safe fallback for unknown names.
 *
 * Icons are an explicit allowlist (named imports) so the rest of the lucide
 * set tree-shakes out of the portal bundle — a namespace import would pull
 * all ~1500 icons. When a manifest/config declares a new icon name, add it
 * to the map below; unknown names fall back to Database.
 */
import {
    Briefcase,
    Calendar,
    CheckCircle,
    Database,
    Edit,
    FileText,
    GraduationCap,
    Home,
    LifeBuoy,
    LogOut,
    Package,
    Settings,
    Settings2,
    Shield,
    Trash2,
    User,
    UserCircle,
    Users,
} from "@lucide/vue";
import type { Component } from "vue";

const ICONS: Record<string, Component> = {
    Briefcase,
    Calendar,
    CheckCircle,
    Database,
    Edit,
    FileText,
    GraduationCap,
    Home,
    LifeBuoy,
    LogOut,
    Package,
    Settings,
    Settings2,
    Shield,
    Trash2,
    User,
    UserCircle,
    Users,
};

export function resolveLucideIcon(
    name?: string,
    fallback: Component = Database
): Component {
    if (!name) return fallback;
    return ICONS[name] ?? fallback;
}
